import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createAnnouncement } from "api/apiHelper";
import Card from "components/Card";
import { toast } from "react-toastify";

const CreateAnnouncement = () => {
  const [announcementData, setAnnouncementData] = useState({
    title: "",
    description: "",
    type: "info", // Default to info (Low priority)
    is_active: true,
  });
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value, type } = e.target as
      | HTMLInputElement
      | HTMLTextAreaElement
      | HTMLSelectElement;
    const checked =
      type === "checkbox" ? (e.target as HTMLInputElement).checked : undefined;
    setAnnouncementData({
      ...announcementData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createAnnouncement(announcementData);
      toast.success("Announcement created successfully!");
      navigate("/profile");
    } catch (error) {
      console.error("Error creating announcement", error);
      toast.error("Error creating announcement");
    }
  };

  return (
    <Card extra="w-full p-6 my-5">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Create New Announcement</h2>
      </div>      
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Title Field */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Announcement Title
          </label>
          <input
            type="text"
            name="title"
            value={announcementData.title}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500"
            required
          />
        </div>

        {/* Description Field */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Content
          </label>
          <textarea
            name="description"
            value={announcementData.description}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500"
            rows={4}
            required
          />
        </div>

        {/* Announcement Type Field */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Announcement Priority
          </label>
          <select
            name="type"
            value={announcementData.type}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500"
            required
          >
            <option value="info">Low</option>
            <option value="warning">Medium</option>
            <option value="danger">High</option>
          </select>
        </div>

        {/* Active Checkbox */}
        <div className="flex items-center">
          <input
            type="checkbox"
            name="is_active"
            checked={announcementData.is_active}
            onChange={handleChange}
            id="is_active"
            className="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500"
          />
          <label
            htmlFor="is_active"
            className="ml-2 block text-sm text-gray-700"
          >
            Active
          </label>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="rounded bg-brand-500 px-4 py-2 text-white hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
        >
          Create Announcement
        </button>
      </form>
    </Card>
  );
};

export default CreateAnnouncement;